import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public isMobileMenuOpen: boolean = false;
  public smallSideBarOpen: boolean = true;

  toggleMobileMenu(event) {
    this.isMobileMenuOpen = event;
  }

  toggleSmallSideBar(event) {
    this.smallSideBarOpen = event;
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts